export const PENDING_FRAME_DELAY_MIN_MS = 5000;
export const PENDING_FRAME_DELAY_MAX_MS = 8200;
export const PENDING_RESPONSE_PREFIX = '::hub-pending::';

export const PENDING_RESPONSE_WORDS = [
  'Accomplishing',
  'Actioning',
  'Actualizing',
  'Architecting',
  'Baking',
  'Beaming',
  "Beboppin'",
  'Befuddling',
  'Billowing',
  'Blanching',
  'Bloviating',
  'Boogieing',
  'Boondoggling',
  'Booping',
  'Bootstrapping',
  'Brewing',
  'Burrowing',
  'Calculating',
  'Canoodling',
  'Caramelizing',
  'Cascading',
  'Catapulting',
  'Cerebrating',
  'Channelling',
  'Choreographing',
  'Churning',
  'Clauding',
  'Coalescing',
  'Cogitating',
  'Combobulating',
  'Composing',
  'Computing',
  'Concocting',
  'Considering',
  'Contemplating',
  'Cooking',
  'Crafting',
  'Creating',
  'Crystallizing',
  'Cultivating',
  'Crunching',
  'Deciphering',
  'Deliberating',
  'Determining',
  'Dilly-dallying',
  'Discombobulating',
  'Doing',
  'Doodling',
  'Drizzling',
  'Ebbing',
  'Effecting',
  'Elucidating',
  'Embellishing',
  'Enchanting',
  'Envisioning',
  'Evaporating',
  'Fermenting',
  'Fiddle-faddling',
  'Finagling',
  'Flambéing',
  'Flibbertigibbeting',
  'Flowing',
  'Flummoxing',
  'Fluttering',
  'Forging',
  'Forming',
  'Frosting',
  'Frolicking',
  'Gallivanting',
  'Galloping',
  'Garnishing',
  'Generating',
  'Germinating',
  'Gitifying',
  'Grooving',
  'Gusting',
  'Harmonizing',
  'Hashing',
  'Hatching',
  'Herding',
  'Hibernating',
  'Honking',
  'Hullaballooing',
  'Hyperspacing',
  'Ideating',
  'Imagining',
  'Improvising',
  'Incubating',
  'Inferring',
  'Infusing',
  'Ionizing',
  'Jitterbugging',
  'Julienning',
  'Kneading',
  'Leavening',
  'Levitating',
  'Lollygagging',
  'Manifesting',
  'Marinating',
  'Meandering',
  'Metamorphosing',
  'Misting',
  'Moonwalking',
  'Moseying',
  'Mulling',
  'Mustering',
  'Musing',
  'Nebulizing',
  'Nesting',
  'Noodling',
  'Nucleating',
  'Orbiting',
  'Orchestrating',
  'Osmosing',
  'Perambulating',
  'Percolating',
  'Perusing',
  'Philosophising',
  'Photosynthesizing',
  'Pollinating',
  'Pontificating',
  'Pondering',
  'Pouncing',
  'Precipitating',
  'Prestidigitating',
  'Processing',
  'Proofing',
  'Propagating',
  'Puttering',
  'Puzzling',
  'Quantumizing',
  'Razzle-dazzling',
  'Razzmatazzing',
  'Recombobulating',
  'Reticulating',
  'Roosting',
  'Ruminating',
  'Sautéing',
  'Scampering',
  'Scheming',
  'Schlepping',
  'Scurrying',
  'Seasoning',
  'Shenaniganing',
  'Shimmying',
  'Simmering',
  'Skedaddling',
  'Sketching',
  'Slithering',
  'Smooshing',
  'Sock-hopping',
  'Spelunking',
  'Spinning',
  'Sprouting',
  'Stewing',
  'Sublimating',
  'Sussing',
  'Swirling',
  'Swooping',
  'Symbioting',
  'Synthesizing',
  'Tempering',
  'Thinking',
  'Thundering',
  'Tinkering',
  'Tomfoolering',
  'Topsy-turvying',
  'Transfiguring',
  'Transmuting',
  'Twisting',
  'Undulating',
  'Unfurling',
  'Unravelling',
  'Vibing',
  'Waddling',
  'Wandering',
  'Warping',
  'Whatchamacalliting',
  'Whirlpooling',
  'Whirring',
  'Whisking',
  'Wibbling',
  'Working',
  'Wrangling',
  'Zesting',
  'Zigzagging',
];

let lastPendingWord = '';

export function randomPendingWord(previous = lastPendingWord) {
  if (!PENDING_RESPONSE_WORDS.length) return 'Thinking';
  if (PENDING_RESPONSE_WORDS.length === 1) return PENDING_RESPONSE_WORDS[0];
  let next = PENDING_RESPONSE_WORDS[Math.floor(Math.random() * PENDING_RESPONSE_WORDS.length)];
  let guard = 0;
  while (next === previous && guard < 6) {
    next = PENDING_RESPONSE_WORDS[Math.floor(Math.random() * PENDING_RESPONSE_WORDS.length)];
    guard += 1;
  }
  lastPendingWord = next;
  return next;
}

export function pendingResponseText() {
  return `${PENDING_RESPONSE_PREFIX}${randomPendingWord()}`;
}

export function nextPendingFrameDelay() {
  return Math.round(
    PENDING_FRAME_DELAY_MIN_MS
      + Math.random() * (PENDING_FRAME_DELAY_MAX_MS - PENDING_FRAME_DELAY_MIN_MS),
  );
}

export function pendingWordFromText(text) {
  if (typeof text !== 'string' || !text.startsWith(PENDING_RESPONSE_PREFIX)) return '';
  return text.slice(PENDING_RESPONSE_PREFIX.length).trim();
}
